import React from 'react';

const SignupImpressionsController = ({ children, impressionsData }) => {
  const viewProps = {
    impressionsData,
  };

  return React.cloneElement(children, viewProps);
};

export default SignupImpressionsController;
